import React, { useState, useEffect, useLayoutEffect, useRef, useContext } from 'react';
import { GlobalContext } from 'context/userContext';
import { Grid } from '@mui/material';
import { DrawerHeader } from '@components/drawer-header';
import TableExplorer from '@components/table-explorer/table_explorer';
import { Box, Modal, Typography, FormLabel, Switch, FormControlLabel, FormHelperText, CircularProgress, Paper, useTheme, Button } from '@mui/material';
import { MassUploadModal, Field } from '@components/mass-upload-modal';
import { useForm } from 'react-hook-form';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';

import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import * as S from './styles';
import { AxiosInstanceLongTimeOut } from '../../service/axios-instance';


interface FormData {
  "id": string;
  "tid": number,
  "tipo": string;
  "marca": string;
  "modelo": string;
  "ano": string;
  "reserva": "0" | "1";
  "proxima_preventiva": number;
  "horas_contratadas": number;
  "turnos_contratados": string;
  "setor": string;
  "contato": string;
  "contato_email": string;
  "bloqueio_remoto": "0" | "1";
  "horimetro"?: number;
  "apelido"?: string;
}




export function Equipaments() {
  const { operation, mainUser } = useContext(GlobalContext);
  const theme = useTheme();

  const [saveModalOpen, setsaveModalOpen] = useState<boolean>(false);
  const [massUploadModalOpen, setMassUploadModalOpen] = useState<boolean>(false);
  const [editModalOpen, seteditModalOpen] = useState<boolean>(false);

  const [isNewEquipament, SetIsNewEquipament] = useState<boolean>(false);
  const [clickedRow, setclickedRow] = useState<Record<string, any>>();
  const [table, setTable] = useState<any>(null);

  const tableSaveRef = useRef<any>(null);

  // Replace TID State
  const [replaceTidModalOpen, setReplaceTidModalOpen] = useState(false);
  const [loadingTid, setLoadingTid] = useState(false);
  const newTidRef = useRef<HTMLInputElement>(null);

  // Force Horimetro State
  const [forceHorimetroModalOpen, setForceHorimetroModalOpen] = useState(false);
  const [loadingHorimetro, setLoadingHorimetro] = useState(false);
  const newHorimetroRef = useRef<HTMLInputElement>(null);

  // Transfer Operation State
  const canAdd = mainUser?.roles?.some((role: string) => ['ADICAO', 'MODIFICAO', 'ADMINISTRADOR', 'SUPERADMINISTRADOR', 'Automni-superadmin', 'fleet-admin'].includes(role));
  const canModify = mainUser?.roles?.some((role: string) => ['MODIFICAO', 'ADMINISTRADOR', 'SUPERADMINISTRADOR', 'Automni-superadmin', 'fleet-admin'].includes(role));
  const userIsAdmin = mainUser?.roles?.some((role: string) => ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'Automni-superadmin', 'fleet-admin'].includes(role));
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [targetOperation, setTargetOperation] = useState("");
  const [operationsList, setOperationsList] = useState<string[]>([]);
  const [loadingTransfer, setLoadingTransfer] = useState(false);

  const handleTransferOperation = async () => {
    if (!targetOperation) {
      alert("Selecione a operação de destino");
      return;
    }
    setLoadingTransfer(true);
    try {
      const equipmentId = clickedRow?.data()[0];
      if (!equipmentId) return;

      const response = await AxiosInstanceLongTimeOut.post('/equipaments/transfer_operation?db=' + operation, {
        id: equipmentId,
        target_db: targetOperation
      }, { withCredentials: true });

      if (response.status === 200) {
        alert("Equipamento transferido com sucesso!");
        if (clickedRow) {
          clickedRow.remove().draw(false);
        }
        setTransferModalOpen(false);
        seteditModalOpen(false);
      } else {
        alert(`Erro: ${response.data.message || "Falha desconhecida"}`);
      }
    } catch (e: any) {
      console.error(e);
      const msg = e.response?.data?.message || e.message;
      alert("Erro ao transferir equipamento: " + msg);
    } finally {
      setLoadingTransfer(false);
    }
  };

  const handleReplaceTid = async () => {
    if (!clickedRow || !newTidRef.current) return;
    const currentData = clickedRow.data();
    const equipmentId = currentData[0]; // Index 0 is ID
    const oldTid = currentData[2]; // Index 2 is TID
    const newTidVal = newTidRef.current.value;

    if (!newTidVal) {
      alert("Por favor, informe o novo TID.");
      return;
    }

    setLoadingTid(true);
    try {

      const response = await AxiosInstanceLongTimeOut.post('/equipaments/replace_tid?db=' + operation, {
        id: equipmentId,
        old_tid: toIntOrZero(oldTid),
        new_tid: parseInt(newTidVal, 10),
      }, { withCredentials: true });

      if (response.status === 200) {
        alert("TID substituído com sucesso!");

        // Update local row data
        const updated = clickedRow.data();
        updated[2] = parseInt(newTidVal, 10);
        clickedRow.data(updated).draw(false);

        // Close modals
        setReplaceTidModalOpen(false);
        seteditModalOpen(false);
      } else {
        alert(`Erro: ${response.data.message || "Falha desconhecida"}`);
      }

    } catch (e: any) {
      console.error(e);
      const msg = e.response?.data?.message || e.message;
      alert("Erro ao substituir TID: " + msg);
    } finally {
      setLoadingTid(false);
    }
  };

  const handleForceHorimetro = async () => {
    if (!clickedRow || !newHorimetroRef.current) return;
    const currentData = clickedRow.data();
    const equipmentId = currentData[0]; // Index 0 is ID
    const newHorimetroVal = newHorimetroRef.current.value;

    if (!newHorimetroVal) {
      alert("Por favor, informe o novo valor do horímetro (em horas).");
      return;
    }

    setLoadingHorimetro(true);
    try {
      const response = await AxiosInstanceLongTimeOut.post('/equipaments/force_horimetro_equipament?db=' + operation, {
        id: equipmentId,
        horimetro: parseFloat(newHorimetroVal),
      }, { withCredentials: true });

      if (response.status === 200) {
        alert(response.data.message || "Horímetro forçado com sucesso! Os horímetros anteriores foram invalidados para a análise.");

        // No need to update local row data immediately for horimetro as it is not displayed in the table (it's only horimetro inicial, or wait, is it in the table?)
        // Let's check table columns. index 15 is horimetro, but it's not in visibleColumns.
        // It's safe to just close modals.
        setForceHorimetroModalOpen(false);
        seteditModalOpen(false);
      } else {
        alert(`Erro: ${response.data.message || "Falha desconhecida"}`);
      }
    } catch (e: any) {
      console.error(e);
      const msg = e.response?.data?.message || e.message;
      alert("Erro ao forçar horímetro: " + msg);
    } finally {
      setLoadingHorimetro(false);
    }
  };


  const { register, control, handleSubmit, formState: { errors }, reset } = useForm<FormData>({
    defaultValues: {
    },
  });




  function row_modifier_open_cb(row_instance: Record<string, any>) {
    if (!canModify) return;
    setclickedRow(row_instance);
    SetIsNewEquipament(false);
    const original_data = row_instance.data()

    console.log("abrindo edit modal com", original_data)


    reset({
      id: original_data[0],                    // id
      apelido: original_data[1],               // apelido
      tid: original_data[2],                   // tid
      setor: original_data[3],                 // setor
      tipo: original_data[4],                  // tipo
      modelo: original_data[5],                // modelo
      marca: original_data[6],                 // marca
      ano: original_data[7],                   // ano

      reserva: String(original_data[8]) as "0" | "1", // reserva 
      proxima_preventiva: original_data[9],    // next_preventive
      horas_contratadas: original_data[10],    // hours_contracted
      turnos_contratados: original_data[11],   // shift_hours_contracted

      contato: original_data[12],              // contact
      contato_email: original_data[13],        // contact_email
      bloqueio_remoto: String(original_data[14]) as "0" | "1",  // bloqueio_remoto
    });

    seteditModalOpen(true);
  }


  function set_table_instance_cb(table_instance: any) {
    setTable(table_instance)
  }

  const toIntOrNull = (value: any) => {
    if (value === '' || value === null || value === undefined) return null;
    const n = parseInt(value, 10);
    return Number.isNaN(n) ? null : n;
  };

  const toIntOrZero = (value: any) => {
    if (value === '' || value === null || value === undefined) return 0;
    const n = Number(value);
    return Number.isNaN(n) ? 0 : n;
  };

  const normalizeString = (value: any) => {
    if (value === null || value === undefined || value === 'null') return '';
    return String(value);
  };

  const onSubmit = (data: FormData) => {
    console.log("isNewEquipament", isNewEquipament, "Atualizando tabela com", data);

    // Helper to convert to number safely
    const num = (v: any) => {
      if (v === "" || v === null || v === undefined) return null;
      const n = Number(v);
      return isNaN(n) ? null : n;
    };

    if (isNewEquipament) {
      // ---------- ADD NEW LINE ----------
      if (table) {
        const newRow = [
          data.id,                        // 0
          data.apelido,                   // 1
          num(data.tid),                  // 2
          data.setor,                     // 3
          data.tipo,                      // 4
          data.modelo,                    // 5
          data.marca,                     // 6
          data.ano,                       // 7
          num(data.reserva),              // 8
          num(data.proxima_preventiva),   // 9
          num(data.horas_contratadas),    // 10
          num(data.turnos_contratados),   // 11
          data.contato,                   // 12
          data.contato_email,             // 13
          num(data.bloqueio_remoto),      // 14
          num(data.horimetro)             // 15
        ];

        table.row.add(newRow).draw(false);

      } else {
        alert("Erro ao carregar a tabela, tente novamente");
      }
    }

    else {
      // ---------- EDIT EXISTING LINE ----------
      if (clickedRow) {
        const updated = clickedRow.data();

        updated[0] = data.id;
        updated[1] = data.apelido;
        updated[2] = num(data.tid);
        updated[3] = data.setor;
        updated[4] = data.tipo;
        updated[5] = data.modelo;
        updated[6] = data.marca;
        updated[7] = data.ano;
        updated[8] = num(data.reserva);
        updated[9] = num(data.proxima_preventiva);
        updated[10] = num(data.horas_contratadas);
        updated[11] = num(data.turnos_contratados);
        updated[12] = data.contato;
        updated[13] = data.contato_email;
        updated[14] = num(data.bloqueio_remoto);

        clickedRow.data(updated).draw(false);
      }
    }

    seteditModalOpen(false);
  };



  return (
    <DrawerHeader
      title={"Equipamentos"}
    >
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Paper
            elevation={2}
            sx={{
              p: { xs: 2.5, md: 3 },
              bgcolor: 'background.paper',
              borderLeft: `6px solid ${theme.palette.primary.main}`,
              borderRadius: 2,
              mb: 1
            }}
          >
            <Box>
              <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1.5, fontWeight: 600 }}>
                CADASTRO E CONFIGURAÇÃO
              </Typography>
              <Typography variant="h4" fontFamily="Saira" fontWeight={900} color="text.primary">Gestão de Equipamentos</Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                Adicione, modifique ou remova máquinas operacional. Caso necessário também é possivel trocar a telemetria ligada a um determiando aquipamento aqui.
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Grid item display="flex" gap={2}>
          {canAdd && (
            <S.Button onClick={() => {
              reset({
                "id": "0",
                "tid": 0,
                "tipo": "",
                "marca": "",
                "modelo": "",
                "ano": "",
                "reserva": "0",
                "proxima_preventiva": 0,
                "horas_contratadas": 0,
                "turnos_contratados": "",
                "setor": "",
                "contato": "",
                "contato_email": "",
                "bloqueio_remoto": "0",
                "horimetro": 0,
              });
              SetIsNewEquipament(true);
              seteditModalOpen(true);
            }}
            >
              Novo equipamento
            </S.Button>
          )}

          {canAdd && (
            <S.Button style={{ background: 'transparent', color: '#a51033', border: '1px solid #a51033', boxShadow: 'none' }} onClick={() => setMassUploadModalOpen(true)}>
              Importar Planilha
            </S.Button>
          )}
        </Grid>

        <Grid item>
          {(canAdd || canModify) && (
            <S.Button onClick={() => setsaveModalOpen(true)}>{"Salvar Modificações"}</S.Button>
          )}
        </Grid>

      </Grid>

      {
        <TableExplorer dbName={operation}
          tableName={"equipaments"}
          headerContent={
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              py: 0.5,
              px: 1.5,
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.default'
            }}>
              <InfoOutlinedIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
              <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center' }}>
                Para editar ou remover equipamentos, clique na linha do equipamento na lista abaixo.
              </Typography>
            </Box>
          }
          startDate={""}
          endDate={""}
          modifier_cb={row_modifier_open_cb}
          set_table_instance_cb={set_table_instance_cb}
          savefuncRef={tableSaveRef}
          visibleColumns={[
            "id",                   // 0
            "apelido",              // 1
            "tid",                  // 2
            "setor",                // 3
            "tipo",                 // 4
            "modelo",               // 5
            "marca",                // 6
            "ano",                  // 7
            "reserva",              // 8
            "proxima_preventiva",   // 9
            "horas_contratadas",    // 10
            "turnos_contratados",   // 11
            "contato",              // 12
            "contato_email",        // 13
            "bloqueio_remoto",      // 14
          ]}
        />
      }





      {saveModalOpen && (
        <Modal open={saveModalOpen} onClose={() => setsaveModalOpen(false)}>
          <S.ModalContainer>
            <Box
              maxWidth={300}
              justifyContent="center"
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <Typography
                variant="h5"
                color="primary"
                fontWeight={600}
                textAlign="center"
                mt={2}
              >
                Tem certeza que deseja salvar as alterações?
              </Typography>
              <S.ButtonContainer>

                <S.ButtonYes
                  onClick={async () => {
                    try {
                      console.log("calling savetable ref");

                      const allRows = tableSaveRef.current?.getDataArray() ?? [];
                      console.log("ALL ROWS", allRows);

                      const allData = allRows.map((row: any[]) => ({
                        id: String(row[0]),                    // id
                        apelido: normalizeString(row[1]),      // apelido
                        tid: toIntOrZero(row[2]),              // tid
                        setor: normalizeString(row[3]),        // setor
                        tipo: String(row[4]),                  // type
                        modelo: normalizeString(row[5]),       // model
                        marca: normalizeString(row[6]),        // brand
                        ano: normalizeString(row[7]),          // year

                        reserva: toIntOrZero(row[8]),          // reserva (0/1)
                        proxima_preventiva: toIntOrZero(row[9]),  // next_preventive
                        horas_contratadas: toIntOrZero(row[10]), // hours_contracted
                        turnos_contratados: toIntOrZero(row[11]), // turnos/shift

                        contato: normalizeString(row[12]),      // contact
                        contato_email: normalizeString(row[13]),// contact_email

                        bloqueio_remoto: toIntOrZero(row[14]),     // bloqueio_remoto (0/1)
                        horimetro: toIntOrZero(row[15]),          // horimetro (only for new, but keep consistency if needed)
                      }));




                      await tableSaveRef.current?.saveTable({ equipaments: allData });

                      setsaveModalOpen(false);
                    } catch (err: any) {
                      console.error(err);
                      let errorMessage = err.message || "Erro desconhecido";
                      if (err.response?.data) {
                        if (typeof err.response.data === 'string') {
                          errorMessage = err.response.data.length < 200 ? err.response.data : errorMessage;
                        } else if (err.response.data.error || err.response.data.message) {
                          errorMessage = err.response.data.error || err.response.data.message;
                        }
                      }
                      alert(`Erro ao salvar a tabela:\n${errorMessage}`);
                    }
                  }}
                >
                  SIM
                </S.ButtonYes>


                <S.ButtonNo onClick={() => setsaveModalOpen(false)}>NÃO</S.ButtonNo>
              </S.ButtonContainer>
            </Box>
          </S.ModalContainer>
        </Modal>
      )}











      {editModalOpen && (
        <Modal open={editModalOpen} onClose={() => seteditModalOpen(false)}>

          <S.ModalContainer>
            <S.ModalContent>
              <Box sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                zIndex: 10,
              }}>
                <IconButton
                  onClick={() => seteditModalOpen(false)}
                >
                  <CloseIcon />
                </IconButton>
              </Box>

              <Box
                sx={{
                  width: '100%',
                  maxWidth: 1200,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* ---------------- HEADER ---------------- */}

                <Typography
                  variant="h5"
                  color="primary"
                  fontWeight={600}
                  textAlign="center"
                >
                  {isNewEquipament ? 'Novo Equipamento' : 'Modificar Equipamento'}

                </Typography>

                {/* ---------------- FORM ---------------- */}

                <Box component="form"
                  onSubmit={handleSubmit(onSubmit)}
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    mt: 2
                  }}
                >
                  {/* GRID 2 COLUNAS on Desktop, 1 COLUNA on Mobile */}
                  <Grid container spacing={3}>

                    <Grid item xs={12} sm={6} lg={3}>
                      <TextField label="Id" fullWidth variant="outlined" disabled={!isNewEquipament} sx={{ mb: 2 }} {...register("id", { required: true, maxLength: 20 })} error={!!errors.id} helperText={"Id da máquina é obrigatorio"} />
                      <TextField label="Tid" fullWidth type="number" variant="outlined" disabled={!isNewEquipament} sx={{ mb: 2 }} {...register("tid", { required: true, maxLength: 20 })} error={!!errors.tid} helperText={"Id da Telemetria é obrigatorio"} />
                      <TextField label="Apelido" fullWidth variant="outlined" sx={{ mb: 2 }} {...register("apelido", { maxLength: 50 })} error={!!errors.apelido} />
                      {isNewEquipament && (
                        <TextField label="Horimetro Inicial" fullWidth type="number" variant="outlined" sx={{ mb: 2 }} {...register("horimetro")} error={!!errors.horimetro} />
                      )}
                      <Controller name="bloqueio_remoto" control={control} rules={{ required: true }} render={({ field }) => (
                        <FormControl fullWidth error={!!errors.bloqueio_remoto} sx={{ mb: 2 }}>
                          <InputLabel id="type-label-bloqueio">bloqueio_remoto</InputLabel>
                          <Select labelId="type-label-bloqueio" value={field.value ?? ''} onChange={field.onChange} label="bloqueio_remoto" disabled={!isNewEquipament}>
                            <MenuItem value="0">Liberado</MenuItem>
                            <MenuItem value="1">Bloqueado</MenuItem>
                          </Select>
                          <FormHelperText>{"bloqueio_remoto é obrigatorio"}</FormHelperText>
                        </FormControl>
                      )} />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3}>
                      <Controller name="tipo" control={control} rules={{ required: "Tipo de máquina é obrigatório" }} render={({ field }) => (
                        <FormControl fullWidth error={!!errors.tipo} sx={{ mb: 2 }}>
                          <InputLabel id="tipo-label">Tipo</InputLabel>
                          <Select labelId="tipo-label" label="Tipo" value={field.value ?? ""} onChange={field.onChange}>
                            <MenuItem value="Contrabalançada">Contrabalançada Elétrica</MenuItem>
                            <MenuItem value="Contrabalançada Combustão">Contrabalançada Combustão</MenuItem>
                            <MenuItem value="Contrabalançada Diesel">Contrabalançada Diesel</MenuItem>
                            <MenuItem value="Rebocador">Rebocador Elétrico</MenuItem>
                            <MenuItem value="Rebocador Combustão">Rebocador Combustão</MenuItem>
                            <MenuItem value="Rebocador Diesel">Rebocador Diesel</MenuItem>
                            <MenuItem value="Articulada">Empilhadeira Articulada</MenuItem>
                            <MenuItem value="Retrátil">Empilhadeira Retrátil</MenuItem>
                            <MenuItem value="Patolada">Empilhadeira Patolada</MenuItem>
                            <MenuItem value="Transpaleteira">Transpaleteira</MenuItem>
                            <MenuItem value="Selecionadora Vertical">Selecionadora Vertical</MenuItem>
                            <MenuItem value="Selecionadora Horizontal">Selecionadora Horizontal</MenuItem>
                          </Select>
                          <FormHelperText>{errors.tipo?.message || "Selecione o tipo de máquina"}</FormHelperText>
                        </FormControl>
                      )} />
                      <TextField label="Marca" fullWidth variant="outlined" sx={{ mb: 2 }} {...register("marca", { required: true, maxLength: 20 })} error={!!errors.marca} helperText={"Marca da máquina é obrigatorio"} />
                      <TextField label="Modelo" fullWidth variant="outlined" sx={{ mb: 2 }} {...register("modelo", { required: true, maxLength: 20 })} error={!!errors.modelo} helperText={"Modelo da máquina é obrigatorio"} />
                      <TextField label="Ano" fullWidth variant="outlined" sx={{ mb: 2 }} {...register("ano", { maxLength: 20 })} error={!!errors.ano} />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3}>
                      <Controller name="reserva" control={control} rules={{ required: true }} render={({ field }) => (
                        <FormControl fullWidth error={!!errors.reserva} sx={{ mb: 2 }}>
                          <InputLabel id="type-label-reserva">reserva</InputLabel>
                          <Select labelId="type-label-reserva" value={field.value ?? ''} onChange={field.onChange} label="reserva">
                            <MenuItem value="0">Normal</MenuItem>
                            <MenuItem value="1">reserva</MenuItem>
                          </Select>
                          <FormHelperText>{"reserva é obrigatorio"}</FormHelperText>
                        </FormControl>
                      )} />
                      <TextField label="horas_contratadas" fullWidth type="number" variant="outlined" sx={{ mb: 2 }} {...register("horas_contratadas", { required: false, maxLength: 20 })} error={!!errors.horas_contratadas} />
                      <TextField label="turnos_contratados" fullWidth variant="outlined" sx={{ mb: 2 }} {...register("turnos_contratados", { maxLength: 20 })} error={!!errors.turnos_contratados} />
                      <TextField label="setor" fullWidth variant="outlined" sx={{ mb: 2 }} {...register("setor", { required: true, maxLength: 20 })} error={!!errors.setor} helperText={"setor é obrigatorio"} />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3}>
                      <TextField label="contato" fullWidth variant="outlined" sx={{ mb: 2 }} {...register("contato", { required: false, maxLength: 20 })} error={!!errors.contato} />
                      <TextField label="contato_email" fullWidth variant="outlined" type="email" sx={{ mb: 2 }} {...register("contato_email", { required: false, maxLength: { value: 100, message: "Máximo de 100 caracteres", }, pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "E-mail inválido", }, })} error={!!errors.contato_email} helperText={errors.contato_email?.message} />
                      <TextField label="proxima_preventiva" fullWidth type="number" variant="outlined" sx={{ mb: 2 }} {...register("proxima_preventiva", { required: false, maxLength: 20 })} error={!!errors.proxima_preventiva} />
                    </Grid>
                  </Grid>


                  {/* ---------------- FOOTER ---------------- */}
                  <Box display="flex" justifyContent="flex-end" sx={{ mt: 4, gap: 1.5, flexWrap: 'nowrap', overflowX: 'auto' }}>

                    <S.ButtonYes type="submit" style={{ width: 'auto', minWidth: 'fit-content' }}>Confirma</S.ButtonYes>

                    {(!isNewEquipament) && (
                      <>
                        {canModify && (
                          <S.ButtonNo
                            type="button"
                            style={{ backgroundColor: '#e65100', width: 'auto', minWidth: 'fit-content' }}
                            onClick={() => setForceHorimetroModalOpen(true)}
                          >
                            Forçar Horímetro
                          </S.ButtonNo>
                        )}

                        {canModify && (
                          <S.ButtonNo
                            type="button"
                            style={{ backgroundColor: '#1976d2', width: 'auto', minWidth: 'fit-content' }}
                            onClick={() => setReplaceTidModalOpen(true)}
                          >
                            Substituir Telemetria
                          </S.ButtonNo>
                        )}

                        {userIsAdmin && (
                          <S.ButtonNo
                            type="button"
                            style={{ backgroundColor: '#9c27b0', width: 'auto', minWidth: 'fit-content' }}
                            onClick={async () => {
                              try {
                                const res = await AxiosInstanceLongTimeOut.get('/general/get_dbs', { withCredentials: true });
                                setOperationsList(res.data.filter((db: string) => db !== operation));
                                setTargetOperation("");
                                setTransferModalOpen(true);
                              } catch (err) {
                                alert("Erro ao buscar operações");
                              }
                            }}
                          >
                            Transferir Operação
                          </S.ButtonNo>
                        )}

                        {canModify && (
                          <S.ButtonNo type="button" style={{ width: 'auto', minWidth: 'fit-content' }} onClick={() => {
                            if (clickedRow) {
                              clickedRow.remove().draw(false);
                            }
                            seteditModalOpen(false);
                          }}>Remove Equipamento
                          </S.ButtonNo>
                        )}
                      </>
                    )}
                  </Box>

                </Box>
              </Box>
            </S.ModalContent>
          </S.ModalContainer>
        </Modal>
      )}







      {/* MODAL SUBSTITUIR TELEMETRIA */}
      <Modal open={replaceTidModalOpen} onClose={() => setReplaceTidModalOpen(false)}>
        <S.ModalContainer>
          <Box
            maxWidth={400}
            justifyContent="center"
            display="flex"
            flexDirection="column"
            alignItems="center"
            p={3}
            bgcolor="white"
            borderRadius={2}
          >
            <Typography variant="h6" mb={2}>Substituir Telemetria</Typography>
            <Typography variant="body2" mb={2} textAlign="center">
              Digite o novo Telemetry ID (TID) para este equipamento.
              Isso atualizará o registro global e o equipamento atual.
            </Typography>
            <TextField
              label="Novo TID"
              type="number"
              fullWidth
              inputRef={newTidRef}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <S.ButtonContainer>
              <S.ButtonYes onClick={handleReplaceTid} disabled={loadingTid}>
                {loadingTid ? <CircularProgress size={24} /> : "CONFIRMAR"}
              </S.ButtonYes>
              <S.ButtonNo onClick={() => setReplaceTidModalOpen(false)} disabled={loadingTid}>
                CANCELAR
              </S.ButtonNo>
            </S.ButtonContainer>
          </Box>
        </S.ModalContainer>
      </Modal>

      {/* MODAL FORÇAR HORÍMETRO */}
      <Modal open={forceHorimetroModalOpen} onClose={() => setForceHorimetroModalOpen(false)}>
        <S.ModalContainer>
          <Box
            maxWidth={400}
            justifyContent="center"
            display="flex"
            flexDirection="column"
            alignItems="center"
            p={3}
            bgcolor="white"
            borderRadius={2}
          >
            <Typography variant="h6" mb={2}>Forçar Horímetro</Typography>
            <Typography variant="body2" mb={1} textAlign="center">
              Digite o novo valor do horímetro (em horas) para este equipamento.
              Isso atualizará o registro e enviará o novo valor para a máquina.
            </Typography>
            <Typography variant="caption" mb={2} textAlign="center" color="text.secondary">
              Atenção: Os horímetros anteriores deste equipamento serão invalidados na análise, que iniciará a partir deste valor em diante.
            </Typography>
            <TextField
              label="Novo Horímetro (Horas)"
              type="number"
              fullWidth
              inputProps={{ step: "0.01" }}
              inputRef={newHorimetroRef}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <S.ButtonContainer>
              <S.ButtonYes onClick={handleForceHorimetro} disabled={loadingHorimetro}>
                {loadingHorimetro ? <CircularProgress size={24} /> : "CONFIRMAR"}
              </S.ButtonYes>
              <S.ButtonNo onClick={() => setForceHorimetroModalOpen(false)} disabled={loadingHorimetro}>
                CANCELAR
              </S.ButtonNo>
            </S.ButtonContainer>
          </Box>
        </S.ModalContainer>
      </Modal>

      {/* MODAL TRANSFERIR OPERAÇÃO */}
      <Modal open={transferModalOpen} onClose={() => setTransferModalOpen(false)}>
        <S.ModalContainer>
          <Box
            maxWidth={400}
            justifyContent="center"
            display="flex"
            flexDirection="column"
            alignItems="center"
            p={3}
            bgcolor="white"
            borderRadius={2}
          >
            <Typography variant="h6" mb={2}>Transferir Operação</Typography>
            <Typography variant="body2" mb={2} textAlign="center">
              Selecione a operação de destino para este equipamento.
              Isso atualizará os registros necessários e a telemetria.
            </Typography>
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel id="target-op-label">Operação de Destino</InputLabel>
              <Select
                labelId="target-op-label"
                value={targetOperation}
                label="Operação de Destino"
                onChange={(e) => setTargetOperation(e.target.value)}
              >
                {operationsList.map((op) => (
                  <MenuItem key={op} value={op}>{op}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <S.ButtonContainer>
              <S.ButtonYes onClick={handleTransferOperation} disabled={loadingTransfer}>
                {loadingTransfer ? <CircularProgress size={24} /> : "CONFIRMAR"}
              </S.ButtonYes>
              <S.ButtonNo onClick={() => setTransferModalOpen(false)} disabled={loadingTransfer}>
                CANCELAR
              </S.ButtonNo>
            </S.ButtonContainer>
          </Box>
        </S.ModalContainer>
      </Modal>

      <MassUploadModal
        open={massUploadModalOpen}
        onClose={() => setMassUploadModalOpen(false)}
        fields={[
          { name: 'id', label: 'ID Máquina', required: true },
          { name: 'apelido', label: 'Apelido (Nome)', required: true },
          { name: 'tid', label: 'TID', required: true },
          { name: 'setor', label: 'Setor / Área', required: true },
          { name: 'tipo', label: 'Tipo' },
          { name: 'modelo', label: 'Modelo', required: true },
          { name: 'marca', label: 'Marca', required: true },
          { name: 'ano', label: 'Ano' },
          { name: 'reserva', label: 'Reserva (0/1)' },
          { name: 'proxima_preventiva', label: 'Próxima Preventiva (Horas)' },
          { name: 'horas_contratadas', label: 'Horas Contratadas' },
          { name: 'turnos_contratados', label: 'Turnos Contratados' },
          { name: 'contato', label: 'Contato' },
          { name: 'contato_email', label: 'E-mail do Contato' },
          { name: 'bloqueio_remoto', label: 'Bloqueio Remoto (0/1)' },
          { name: 'horimetro', label: 'Horímetro Inicial' },
        ]}
        onUpload={(data) => {
          if (!table) return;

          const num = (v: any) => {
            if (v === "" || v === null || v === undefined) return null;
            const n = Number(v);
            return isNaN(n) ? null : n;
          };

          const rowsToAdd = data.map((d: any) => {
            return [
              d['id'] || "",                            // 0
              d['apelido'] || "",                       // 1
              num(d['tid']),                            // 2
              d['setor'] || "",                         // 3
              d['tipo'] || "",                          // 4
              d['modelo'] || "",                        // 5
              d['marca'] || "",                         // 6
              d['ano'] || "",                           // 7
              num(d['reserva']) || 0,                   // 8
              num(d['proxima_preventiva']) || 0,        // 9
              num(d['horas_contratadas']) || 0,         // 10
              num(d['turnos_contratados']) || 0,        // 11
              d['contato'] || "",                       // 12
              d['contato_email'] || "",                 // 13
              num(d['bloqueio_remoto']) || 0,           // 14
              num(d['horimetro']) || 0                  // 15
            ];
          });

          let updatedCount = 0;
          let addedCount = 0;

          rowsToAdd.forEach(newRow => {
            const tid = newRow[2];
            let foundIndex = -1;

            if (tid !== null && tid !== "") {
              const indexes = table.rows().indexes().toArray();
              for (let i = 0; i < indexes.length; i++) {
                if (Number(table.cell(indexes[i], 2).data()) === Number(tid)) {
                  foundIndex = indexes[i];
                  break;
                }
              }
            }

            if (foundIndex !== -1) {
              // Preserve the original ID so it correctly updates in the backend
              const existingRowData = table.row(foundIndex).data();
              if (!newRow[0] && existingRowData[0]) {
                newRow[0] = existingRowData[0];
              }
              table.row(foundIndex).data(newRow);
              updatedCount++;
            } else {
              table.row.add(newRow);
              addedCount++;
            }
          });

          table.draw(false);
          alert(`${addedCount} equipamentos adicionados e ${updatedCount} atualizados na tabela! Clique em "Salvar Modificações" para gravar no banco.`);
        }}
      />

    </DrawerHeader>
  );
}

